import { CommonModule } from '@angular/common';

import {
    Component,
    InputSignal,
    effect,
    inject,
    input,
    output,
} from '@angular/core';
import { IqEventBusBrokerService } from '@dat/iq-event-bus';
import { IqRateLaneUtilsStateService } from '../state';

@Component({
    selector: 'iq-rate-lane-utils-fuel-loader',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './iq-rate-lane-utils-fuel-loader.component.html',
    styleUrl: './iq-rate-lane-utils-fuel-loader.component.scss',
})
export class IqRateLaneUtilsFuelLoaderComponent {
    id: InputSignal<string> = input<string>('');
    equipmentType: InputSignal<string> = input<string>();
    dashboardId: InputSignal<string> = input<string>('');
    quote: InputSignal<any> = input<any>({});
    mileage: InputSignal<number> = input<number>();
    private _eventBus: IqEventBusBrokerService = inject(
        IqEventBusBrokerService,
    );

    constructor(private readonly _state: IqRateLaneUtilsStateService) {
        effect(async () => {
            // we need to make sure we have mileage & equipment type or we won't be able to update the fuel label on load
            if (this.mileage() && this.equipmentType()) {
                const dailyFuel = await this._state.getFuelSurcharge();
                const fuelValue =
                    (this.quote().fuelType ?? 'default') === 'default'
                        ? dailyFuel[this.equipmentType()]
                        : this.quote().fuel ?? dailyFuel[this.equipmentType()];

                /**
                 * This dispatches an event when the fuel is loaded
                 *
                 *
                 * To listen to these events, you can use the following format in your Dashboard, Section, or Component:
                 *
                 * ```json
                 * {
                 *  "onLoad": [
                 *    {
                 *      "name": "EVENT_NAME",
                 *      "payload": {},
                 *      "sourceEventRule": {
                 *          "payload": [
                 *            {
                 *                "path": "id",
                 *                "operator": "eq",
                 *                "value": "COMPONENT_ID"
                 *            },
                 *            {
                 *                "path": "componentName",
                 *                "operator": "eq",
                 *                "value": "IqRateLaneUtilsFuelLoader"
                 *            },
                 *          ]
                 *      },
                 *      "rules": []
                 *    },
                 *   ],
                 * }
                 * ```
                 */
                const dispatch = () =>
                    this._eventBus.dispatch({
                        name: 'type:load',
                        payload: {
                            id: this.id(),
                            componentName: 'IqRateLaneUtilsFuelLoader',
                            dailyFuel,
                            fuelValue,
                        },
                    });

                dispatch();
            }
        });
    }
}
